import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14dd807e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  style: {"margin":"0.2em","width":"100%"}
}
const _hoisted_2 = {
  class: "F-Bold",
  style: {"padding-bottom":"0.2em"}
}
const _hoisted_3 = {
  key: 0,
  class: "CookiesRowSplitter"
}
const _hoisted_4 = {
  key: 2,
  class: "CookiesRowSplitter P-Rel"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "M-Auto",
  style: {"flex":"3","text-align":"start"}
}
const _hoisted_7 = {
  class: "M-Auto InFlex CookiesFade",
  style: {"gap":"0.5em"}
}
const _hoisted_8 = {
  key: 0,
  class: "M-Auto InFlex CookiesFade",
  style: {"gap":"0.5em"}
}
const _hoisted_9 = {
  key: 1,
  class: "CookiesRowSplitter"
}
const _hoisted_10 = {
  key: 0,
  class: "W-100 D-Flex CookiesFade P_25em",
  style: {"font-size":"0.9em","text-align":"start"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "CookiesRowSplitter",
  style: {"margin-top":"2em"}
}, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "W-100 D-Flex CookiesFade",
  style: {"font-size":"0.9em"}
}
const _hoisted_13 = {
  key: 5,
  class: "CookiesRowSplitter"
}
const _hoisted_14 = { style: {"margin-bottom":"0.5em"} }
const _hoisted_15 = {
  key: 0,
  class: "W-100 D-Flex CookiesFade FlexColumn",
  style: {"font-size":"0.7em"}
}
const _hoisted_16 = {
  class: "D-Flex FlexColumn",
  style: {"gap":"0.5em"}
}
const _hoisted_17 = {
  class: "D-Flex Pointer",
  style: {"gap":"1em"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_19 = {
  class: "D-Flex FlexColumn Pointer",
  style: {"gap":"0.5em"}
}
const _hoisted_20 = {
  class: "D-Flex",
  style: {"gap":"1em"}
}
const _hoisted_21 = {
  key: 7,
  class: "W-100 D-Flex CookiesFade",
  style: {"justify-content":"center","flex-direction":"column"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!
  const _component_CookiesNumberInput = _resolveComponent("CookiesNumberInput")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["FilterArea Shadow1", _ctx.ShowFilter ? '': 'FilterHidden']),
    style: {"font-size":"0.89em"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Translate('Filter')), 1),
      _createVNode(_component_CookiesIcon, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('CloseMe'))),
        class: "P-Abs HoverUp CloseButton",
        style: {"width":"2em","height":"2em","right":"1em","top":"1em"},
        ID: 'Close'
      }),
      (_ctx.FilterSettings.Lists && _ctx.FilterSettings.Lists.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.FilterSettings.Lists)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.FilterSettings.Lists, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.Res
            }, [
              (item.Visible === undefined || item.Visible)
                ? (_openBlock(), _createBlock(_component_CookiesDropInputObject, {
                    key: 0,
                    style: {"margin":"0.4em 0em"},
                    PreserveMemory: true,
                    Res: item.Res,
                    Selectors: item.Selectors,
                    Name: _ctx.Translate(item.Name),
                    Options: item.Options
                  }, null, 8, ["Res", "Selectors", "Name", "Options"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.FilterSettings.Checks && _ctx.FilterSettings.Checks.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.FilterSettings.Checks)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.FilterSettings.Checks, (CheckBoxGroup) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: CheckBoxGroup }, [
              _createElementVNode("div", {
                onClick: ($event: any) => (_ctx.MEMWrite('ChecksGroupOpen_' + CheckBoxGroup.GroupName, _ctx.MEMRead('ChecksGroupOpen_' + CheckBoxGroup.GroupName) ? false : true)),
                class: "D-Flex BG3Fixed Rad1 Shadow1 HoverUp P-Rel",
                style: {"font-size":"1em","padding":"0.5em","z-index":"5"}
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Translate(CheckBoxGroup.GroupName)), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_CookiesIcon, {
                    style: _normalizeStyle([_ctx.MEMRead('ChecksGroupOpen_' + CheckBoxGroup.GroupName) ? 'transform:ScaleY(-1);' : '', {}]),
                    onClick: ($event: any) => (_ctx.AllFilterSelector(CheckBoxGroup, false)),
                    class: "SQR1em",
                    ID: ('SortingArrow' as IconsIDs)
                  }, null, 8, ["style", "onClick", "ID"])
                ])
              ], 8, _hoisted_5),
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.MEMRead('ChecksGroupOpen_' + CheckBoxGroup.GroupName) ? 'FilterGroupOpened' : 'FilterGroupClosed', "InputColor D-Flex FlexColumn Rad2 P-Rel FilterGroupCollapse"])
              }, [
                (CheckBoxGroup.Checks && CheckBoxGroup.Checks.length > 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_CookiesIcon, {
                        ToolTip: _ctx.Translate('Check All'),
                        onClick: ($event: any) => (_ctx.AllFilterSelector(CheckBoxGroup, true)),
                        class: "HoverUp SQR2em F_85em",
                        style: {},
                        ID: 'Select'
                      }, null, 8, ["ToolTip", "onClick"]),
                      _createVNode(_component_CookiesIcon, {
                        ToolTip: _ctx.Translate('Uncheck All'),
                        onClick: ($event: any) => (_ctx.AllFilterSelector(CheckBoxGroup, false)),
                        class: "HoverUp SQR2em F_85em",
                        style: {},
                        ID: 'Deselect'
                      }, null, 8, ["ToolTip", "onClick"])
                    ]))
                  : _createCommentVNode("", true),
                (CheckBoxGroup.Checks && CheckBoxGroup.Checks.length > 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(CheckBoxGroup.Checks, (CheckBox) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: CheckBox.Res
                  }, [
                    (CheckBox.Visible === undefined || CheckBox.Visible)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (CheckBox.Icon)
                            ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                                key: 0,
                                style: {"width":"1.75em","height":"1.75em"},
                                ID: CheckBox.Icon
                              }, null, 8, ["ID"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_CookiesCheckBox, {
                            style: {"margin":"auto 0.2em"},
                            Default: CheckBox.Default === undefined ? true : CheckBox.Default,
                            Res: CheckBox.Res,
                            Name: _ctx.Translate(CheckBox.Name)
                          }, null, 8, ["Default", "Res", "Name"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], 2),
              _hoisted_11
            ], 64))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.FilterSettings.Switches)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.FilterSettings.Switches, (Switch) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: Switch.Res
            }, [
              (Switch.Visible === undefined || Switch.Visible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (Switch.Icon)
                      ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                          key: 0,
                          style: {"width":"2.1em","height":"2.1em","margin-bottom":"0.2em"},
                          ID: Switch.Icon
                        }, null, 8, ["ID"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_CookiesCheckBox, {
                      style: {"margin":"auto 0.2em"},
                      Type: 'Switch',
                      Default: Switch.Default === undefined ? false : Switch.Default,
                      Res: Switch.Res,
                      Name: _ctx.Translate(Switch.Name)
                    }, null, 8, ["Default", "Res", "Name"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.FilterSettings.Values)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13))
        : _createCommentVNode("", true),
      (_ctx.FilterSettings.Values)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 6 }, _renderList(_ctx.FilterSettings.Values, (value) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: value.Res
            }, [
              _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.Translate(value.Name)), 1),
              (value.Visible === undefined || value.Visible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Min')), 1),
                        (_ctx.MEMRead(value.Res + '_Min') !== '')
                          ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                              key: 0,
                              onClick: ($event: any) => (this.MEMWrite(value.Res + '_Min', '')),
                              class: "SQR2em",
                              ID: 'Removed'
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_CookiesNumberInput, {
                        Res: value.Res + '_Min'
                      }, null, 8, ["Res"])
                    ]),
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Max')), 1),
                        (_ctx.MEMRead(value.Res + '_Max') !== '')
                          ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                              key: 0,
                              onClick: ($event: any) => (this.MEMWrite(value.Res + '_Max', '')),
                              class: "SQR2em",
                              ID: 'Removed'
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_CookiesNumberInput, {
                        Res: value.Res + '_Max'
                      }, null, 8, ["Res"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.FilterSettings.Dates)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.LanguageSelector('From', 'من')), 1),
              _withDirectives(_createElementVNode("input", {
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.DatesChanged())),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.DateFrom) = $event)),
                class: "CookiesInput color2",
                type: "date"
              }, null, 544), [
                [_vModelText, _ctx.DateFrom]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.LanguageSelector('To', 'الى')), 1),
              _withDirectives(_createElementVNode("input", {
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.DatesChanged())),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.DateTo) = $event)),
                class: "CookiesInput color2",
                type: "date"
              }, null, 544), [
                [_vModelText, _ctx.DateTo]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}